
    import './styles.scoped.css';
    export default {
  "segment__path": "awsui_segment__path_1edmh_912m4_97",
  "segment": "awsui_segment_1edmh_912m4_97",
  "segment__hover": "awsui_segment__hover_1edmh_912m4_124",
  "label": "awsui_label_1edmh_912m4_138",
  "root": "awsui_root_1edmh_912m4_156",
  "filter-container": "awsui_filter-container_1edmh_912m4_168",
  "has-default-filter": "awsui_has-default-filter_1edmh_912m4_172",
  "content": "awsui_content_1edmh_912m4_176",
  "content--small": "awsui_content--small_1edmh_912m4_182",
  "content--without-labels": "awsui_content--without-labels_1edmh_912m4_185",
  "content--medium": "awsui_content--medium_1edmh_912m4_188",
  "content--large": "awsui_content--large_1edmh_912m4_194",
  "content--reserve-filter": "awsui_content--reserve-filter_1edmh_912m4_200",
  "content--reserve-legend": "awsui_content--reserve-legend_1edmh_912m4_203",
  "status-container": "awsui_status-container_1edmh_912m4_207",
  "chart-container": "awsui_chart-container_1edmh_912m4_211",
  "inner-content": "awsui_inner-content_1edmh_912m4_216",
  "segment__highlight": "awsui_segment__highlight_1edmh_912m4_230",
  "segment--dimmed": "awsui_segment--dimmed_1edmh_912m4_245",
  "segment--highlighted": "awsui_segment--highlighted_1edmh_912m4_248",
  "label--dimmed": "awsui_label--dimmed_1edmh_912m4_265",
  "label--align-right": "awsui_label--align-right_1edmh_912m4_268",
  "label-text": "awsui_label-text_1edmh_912m4_276",
  "label__description": "awsui_label__description_1edmh_912m4_282",
  "label-line": "awsui_label-line_1edmh_912m4_289",
  "label--highlighted": "awsui_label--highlighted_1edmh_912m4_293",
  "popover-header": "awsui_popover-header_1edmh_912m4_297"
};
  